/**
 * Amazon Seller Central–style banner when a buyer requested cancellation.
 * Admin still cancels in Seller Central — CRM only surfaces the request.
 */
export function BuyerCancelRequestBanner({ order }) {
  if (!order?.buyerRequestedCancel) {
    return null;
  }

  const reason = order.buyerCancelReason?.trim();
  const sellerCentralUrl =
    order.marketplace === 'US'
      ? `https://sellercentral.amazon.com/orders-v3/order/${encodeURIComponent(order.amazonOrderId || '')}`
      : `https://sellercentral.amazon.in/orders-v3/order/${encodeURIComponent(order.amazonOrderId || '')}`;

  return (
    <div className="mb-2 rounded-md border border-amber-300 bg-[#fff8e7] px-3 py-2 text-[13px] text-amber-950">
      <p className="font-medium leading-snug">
        The buyer has requested that this order be cancelled. Please cancel the order in Amazon
        Seller Central and avoid handover to the carrier. Cancelling this order will not affect
        your cancellation rate metric.
      </p>
      {reason ? (
        <p className="mt-1.5 flex items-start gap-1.5 text-[12px] text-amber-900">
          <span className="mt-0.5 inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-amber-500 text-[10px] font-bold text-white">
            !
          </span>
          <span>
            <span className="font-semibold">Buyer cancellation</span>
            <span className="mt-0.5 block text-amber-800">Cancellation reason: {reason}</span>
          </span>
        </p>
      ) : (
        <p className="mt-1.5 text-[12px] font-semibold text-amber-900">Buyer cancellation requested</p>
      )}
      <a
        href={sellerCentralUrl}
        target="_blank"
        rel="noreferrer"
        className="mt-2 inline-flex text-[12px] font-semibold text-[#007185] hover:text-[#c45500] hover:underline"
      >
        Open in Seller Central →
      </a>
    </div>
  );
}
